// 报错信息
const spaceMsg = "请不要输入空字符串";
const alphanumericMsg = "营业执照号只能输入数字和字母哦";
const webMsg = "请输入正确的网址";

// 验证 所有表单
export function validateForm(data) {
  data.map(item => {
    item.validate();
  });

  const result = data.some(item => {
    if (item.errMessage.show) {
      return true;
    }
  });
  return result;
}

// 验证 只输入空格
export function validateSpace(value) {
  return /^ +$/.test(value);
}

// 验证 只有数字、字母
export function validateAlphanumeric(value) {
  if (validateSpace(this.data)) {
    this.errMessage.show = true;
    this.errMessage.text = spaceMsg;
    return;
  }

  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data.replace(/\W+/g, "");
    if (!/^[0-9a-zA-Z]+$/.test(this.data)) {
      this.errMessage.show = true;
      this.errMessage.text = alphanumericMsg;
    } else {
      this.errMessage.show = false;
      this.errMessage.text = "";
    }
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 是否必填项目
export function validateRequired() {

  if (validateSpace(this.data)) {
    this.errMessage.show = true;
    this.errMessage.text = spaceMsg;
    return;
  }

  if (this.require && (this.data === "" || this.data == null)) {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 地址
export function validateAddress() {
  if (validateSpace(this.data["detail"])) {
    this.errMessage.show = true;
    this.errMessage.text = spaceMsg;
    return;
  }

  // 判断是否必填
  if (this.require) {
    const result = Object.keys(this.data).some(item => {
      if (this.data[item] === "") {
        return true;
      }
    });
    // 判断是否有未填写字段
    if (result) {
      this.errMessage.show = true;
      this.errMessage.text = this.warn;
    } else {
      this.errMessage.show = false;
      this.errMessage.text = "";
    }
  } else {
    let str = "";
    for (const _item in this.data) {
      str += this.data[_item];
    }
    // 判断是否填写
    if (!str) {
      // 未填写不验证
      this.errMessage.show = false;
      this.errMessage.text = "";
    } else {
      const result = Object.keys(this.data).some(item => {
        if (this.data[item] === "") {
          return true;
        }
      });
      // 填写，验证是否有为空字段
      if (result) {
        this.errMessage.show = true;
        this.errMessage.text = this.warn;
      } else {
        this.errMessage.show = false;
        this.errMessage.text = "";
      }
    }
  }
}

// 验证 网址
export function validateWeb() {
  if (validateSpace(this.data)) {
    this.errMessage.show = true;
    this.errMessage.text = spaceMsg;
    return;
  }

  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data.replace(/[\u4E00-\u9FFF]+/g, "");
    if (
      !/^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/.test(
        this.data
      )
    ) {
      this.errMessage.show = true;
      this.errMessage.text = webMsg;
    } else {
      this.errMessage.show = false;
      this.errMessage.text = "";
    }
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 大于0的正整数
export function validateInt() {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data.replace(/\D/g, "").replace(/^0+\.?/, "");
    this.errMessage.show = false;
    this.errMessage.text = "";
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 可以有小数点的正数
export function validatePosNumber(msg = "") {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data
      .replace(/[^(\.|\d)]/g, "")
      .replace(/^0+/g, "")
      .replace(/^\./g, "0.");
    this.errMessage.show = false;
    this.errMessage.text = "";
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 数字
export function validateNumber() {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data
      .replace(/[^(\.|\d|\-)]/g, "")
      // .replace(/^0+/g, "")
      .replace(/^\./g, "0.");
    this.errMessage.show = false;
    this.errMessage.text = "";
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 电话
export function validateTel(msg = "") {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data.replace(/\D/g, "");
    if (!/^1[3-9]\d{9}$/.test(this.data)) {
      this.errMessage.show = true;
      this.errMessage.text = `请输入11位的${msg}`;
    } else {
      this.errMessage.show = false;
      this.errMessage.text = "";
    }
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}

// 验证 邮箱
export function validateEmail() {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {
    this.data = this.data.replace(/[\u4E00-\u9FFF]+/g, "");
    if (!/^[-_.a-zA-Z0-9]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/.test(this.data)) {
      this.errMessage.show = true;
      this.errMessage.text = "请正确输入邮箱";
    } else {
      this.errMessage.show = false;
      this.errMessage.text = "";
    }
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}
// 验证 办公电话
export function validateWorkTel(msg = "") {
  if (this.require && this.data === "") {
    this.errMessage.show = true;
    this.errMessage.text = this.warn;
  } else if (this.data != "") {

    this.data = this.data.replace(/\D/g, "");
    console.log(this.data)
    console.log(!/^\d{1,20}$/.test(this.data))
    if (!/^\d{1,20}$/.test(this.data)) {
      this.errMessage.show = true;
      this.errMessage.text = `请输入20位内的数字`;
      return
    }
    this.errMessage.show = false;
    this.errMessage.text = "";
  } else {
    this.errMessage.show = false;
    this.errMessage.text = "";
  }
}